// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  assetId: __t.u64(),
  name: __t.string(),
  layerOrder: __t.i32(),
  enabled: __t.bool(),
  isGround: __t.bool(),
  clipsGround: __t.bool(),
  geoOriginLon: __t.f64(),
  geoOriginLat: __t.f64(),
  geoOriginAlt: __t.f64(),
  geoHeadingDeg: __t.f64(),
  footprintGeojson: __t.string(),
};
